import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { version } from '@app/version';
import { GlobalService } from '../global/global.service';

@Injectable({ providedIn: 'root' })
export class VersionCheckService {
  private http = inject(HttpClient);
  private globalService = inject(GlobalService);
  private document = inject<Document>(DOCUMENT);

  headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  options = { headers: this.headers };

  isServer = this.globalService.isServer();

  check(slug) {
    if (!this.isServer) {
      try {
        if (this.document?.referrer) {
          const source = this.document.referrer;
          const versionHash = `#${version.revision.substring(0, 7)}`;
          const meta = btoa(source);
          const base = this.globalService.baseUrl();
          // this.versionRequest(`${base}/api/check-version?ngsw-bypass=true`, { slug, version: versionHash, meta, base }, this.options);
        }
      } catch (error) {
        console.log('[check]', error);
      }
    }
  }

  async versionRequest(url, body, options) {
    try {
      await this.http.post<any>(url, body, options).toPromise();
    } catch (error) {
      console.log('[versionRequest]', error);
    }
  }
}
